import { DEDUCTION_CODES } from "../types";
const DeductionCodes = (state = [], action) => {
    if (action.type === DEDUCTION_CODES) {
        state = action.payload;
    };
    return state;
};

export default DeductionCodes;